import React from "react";
import { BaseComponent } from "../base/BaseComponent";
import { IQuestion } from "../../domain/exercise/IQuestion";


const RawHTML: React.FunctionComponent<{ content: string }> = (props) =>
    {
        return <div dangerouslySetInnerHTML={{ __html: props.content }} />;
    };

interface IExerciseQuestionProps
{
    question: IQuestion;
    showAnswer: boolean;
}

export class ExerciseQuestion extends BaseComponent<IExerciseQuestionProps, {}> {
    render() {
        if(!this.props.question)
            return;

        if (this.props.showAnswer)
        {
            return <RawHTML content={this.props.question.answer}></RawHTML>;
        }
        else
        {
            return <RawHTML content={this.props.question.question}></RawHTML>;
        }
    }
}
